<div [formGroup]="formGroup">
    <label [for]="controlName" class="form-control-label">
        {{ label }}
        <span class="text-danger">{{
            formGroup.controls[controlName]?.invalid ? '*' : ''
        }}</span>
    </label>
    <div class="input-group">
        <!-- Quando o form estiver disabled (modo visualização), exibe input simples formatado -->
        <input
            *ngIf="formControl.disabled"
            type="text"
            class="form-control"
            [value]="formatDateDisplay(formControl.value)"
            [disabled]="true" />

        <!-- Datepicker normal quando não estiver em modo visualização -->
        <input
            *ngIf="!formControl.disabled"
            type="text"
            [(bsValue)]="selectedDate"
            (bsValueChange)="onDateChange($event)"
            class="form-control"
            placeholder="mm/aaaa"
            mask="00/0000"
            [bsConfig]="{ minMode: 'month', dateInputFormat: 'MM/YYYY' }"
            bsDatepicker
            [ngClass]="{
                'is-invalid':
                    formControl?.invalid &&
                    (formControl?.dirty || formControl?.touched)
            }" />
        <div class="invalid-feedback">
            {{ messages?.invalid || 'Data inválida' }}
        </div>
    </div>
</div>
